import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoIosArrowBack } from 'react-icons/io';

import IdeaFactoryLogo from '../../assets/images/logo.png';
import Button from '../../components/inputs/Button';

import Logo1 from '../../assets/images/course1.png';
import Logo3 from '../../assets/images/course3.png';
import Logo2 from '../../assets/images/course2.png';

function GetStarted() {
  const navigate = useNavigate();
  return (
    <section className="relative h-screen bg-[#F9FAFB]">
      <div className="content">
        <div className="w-full flex items-center justify-between py-8">
          <div className="logo">
            <Link to="/">
              <img
                src={IdeaFactoryLogo}
                className="w-24 h-auto"
                alt="Idea Factory Logo"
              />
            </Link>
          </div>
        </div>
        <img
          src={Logo1}
          alt=""
          className="hidden lg:block w-32 h-auto right-20 absolute"
        />
        <Link to="/" className="">
          <p className="flex items-center gap-2">
            <span className="bg-gray-400 rounded-full p-0.5">
              <IoIosArrowBack />
            </span>
            Back
          </p>
        </Link>
        <div className="flex justify-center items-center w-full mt-10">
          <div className="w-full md:w-2/3 bg-white shadow-lg rounded-lg p-5 md:p-10">
            <h5>Dear Team,</h5>
            <p className="py-1.5">Welcome to your personal learning page!</p>
            <p>
              We are working on creating a customized experience to support your
              learning goals. Over the next few months, we will include exciting
              features to create a seamless one-stop learning experience for
              you.
            </p>
            <p className="py-2">What&apos;s in it for you at Purple Academy?</p>
            <p>
              We want to help you succeed in your role and develop a dynamic,
              successful career at Wema Bank. No matter what you want to achieve
              here, there&apos;s a path for you. Here are a few of what&apos;s
              in store:
            </p>
            <ol className="list-disc py-2">
              <li>Best-in-class physical learning</li>
              <li>Engaging Virtual Instructor-led sessions</li>
              <li>E-learning on Coursera or PluralSight</li>
              <li>Open courses</li>
              <li>International Training</li>
              <li>Team Building and Strategy Sessions</li>
            </ol>
            <p>
              While you wait for us to fully open this learning space, click the
              button below to get started!
            </p>
            <Button
              type="submit"
              className="w-full my-7 text-lg text-center bg-primary py-3 text-white rounded-lg"
              onClick={() => navigate('/programs')}
            >
              Get Started
            </Button>
          </div>
        </div>
        <div className="">
          <img
            src={Logo3}
            alt=""
            className="hidden lg:block w-32 h-32 absolute left-16 -mt-[350px] object-contain"
          />
        </div>
        <div className="">
          <img
            src={Logo2}
            alt=""
            className="hidden lg:block w-32 h-32 absolute right-20 -mt-[280px] object-contain"
          />
        </div>
      </div>
    </section>
  );
}

export default GetStarted;
